import { useEffect } from "react";

// referred const instead of HOC since this is a hook
import { APPLICATION } from "@/constants";

export interface ExtendedWindow extends Window {
  dataLayer?: {
    event?: string;
    event_name?: string;
    trip_type?: string;
    destination?: string;
    destination_additions?: string;
    trip_extra?: string;
    cover_start_date?: string;
    cover_end_date?: string;
    travel_from?: string;
    travel_group_type?: string;
    page_url?: string;
    page_title?: string;
    step_name?: string;
    popup_name?: string;
  }[];
}

type QuestionSetProps = {
  pageTitle?: string;
  tripType?: string;
  pageUrl?: string;
  destination?: string;
  destinationAdditions?: string;
  tripExtra?: string;
  coverStartDate?: string;
  coverEndDate?: string;
  travelFrom?: string;
  travelGroupType?: string;
  isSubmitBtnClicked?: boolean;
};

const useGtmQuestionSet = (props: QuestionSetProps) => {
  const {
    pageTitle,
    tripType,
    pageUrl,
    destination,
    destinationAdditions,
    tripExtra,
    coverEndDate,
    coverStartDate,
    travelFrom,
    travelGroupType,
    isSubmitBtnClicked,
  } = props;

  useEffect(() => {
    const triggerQuestionSet = () => {
      const extendedWindow = window as ExtendedWindow;
      extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];
      extendedWindow.dataLayer.push({
        event: "quote_journey",
        event_name: "quote_trip_details",
        trip_type: tripType,
        destination,
        destination_additions: destinationAdditions,
        trip_extra: tripExtra,
        cover_start_date: coverStartDate,
        cover_end_date: coverEndDate,
        travel_from: travelFrom,
        travel_group_type: travelGroupType,
        page_url: pageUrl,
        page_title: pageTitle,
        step_name: pageTitle,
      });
    };
    if (isSubmitBtnClicked === true && APPLICATION === "quote")
      triggerQuestionSet();
    return () => {
      // Cleanup code if needed
    };
  }, [
    pageTitle,
    tripType,
    pageUrl,
    destination,
    destinationAdditions,
    tripExtra,
    coverEndDate,
    coverStartDate,
    travelFrom,
    travelGroupType,
    isSubmitBtnClicked,
  ]);
};

export default useGtmQuestionSet;
